<template>
    <div :class="isLoading ? 'is-loading' : ''">

        <!-- filters -->
        <aside class="d-print-none">
            <!-- year -->
            <ul class="nav nav-pills flex-nowrap flex-md-wrap gap-3 overflow-auto overflow-md-visible pt-2 pb-3 mb-4 px-2 px-md-0">
                <li class="nav-item">
                    <button :class="['nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.year === '' ? 'active' : '']" @click="selectYear('')">{{ translate('All') }}</button>
                </li>
                <li class="nav-item" v-for="(year, index) in years" :key="index">
                    <button :class="['nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.year === year ? 'active' : '']" @click="selectYear(year)">{{ year }}</button>
                </li>
            </ul>
        </aside>

        <!-- list -->
        <div data-pagination-change-scroll-to>

            <p v-if="!displayedItems.length && !isLoading" class="text-center mb-4">
                {{ translate('No items available') }}
            </p>

            <article v-for="article in displayedItems" :key="article.id" class="link-list-item mb-3">
                <a :href="article.link" class="stretched-link"></a>
                <div class="d-flex">
                    <div class="link-list-item--image rounded-1 overflow-hidden">
                        <img :src="getArticleImage(article.image)" :alt="article.heading" class="img-fluid">
                    </div>
                    <div class="min-w-0 flex-grow-1 px-4 py-3">
                        <p class="text-secondary fw-semibold">
                            <small class="text-nowrap">
                                {{ article.date }}
                            </small>
                        </p>
                        <h3 class="text-truncate h6 my-2">
                            {{ article.heading }}
                        </h3>
                        <p class="text-truncate-lines-3">
                            {{ article.perex }}
                        </p>
                    </div>
                    <div class="flex-shrink-0 d-none d-md-flex align-items-center">
                        <div class="post-arrow">
                            <svg class="icon-post-arrow">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </article>

        </div>

        <div class="mt-5 d-print-none">
            <Pagination 
                :items-count="filteredItems.length"
                v-model:current-page="pagination.currentPage" 
                v-model:per-page="pagination.perPage"
            />
        </div>

    </div>
</template>

<script>
import { paginate } from '@/scripts/helpers/pagination';
import { translate } from '@/scripts/mixins/translations';
import Pagination from '@/components/pagination/Pagination.vue';
import { watchFilters } from '@/scripts/mixins/filters';

export default {
    components: {
        Pagination
    },
    mixins: [
        watchFilters(),
        translate
    ],
    data(){
        return {
            isLoading: false,
            filters: {
                year: new URL(window.location).searchParams.get('year') || '',
            },
            pagination: {
                currentPage: 1,
                perPage: parseInt(localStorage.getItem('list-per-page')) || 10
            },
            years: [],
            news: []
        }
    },
    methods: {
        getArticleImage(url){
            if ( url.length )
            {
                return url;
            }

            return '/client-assets/public/images/tc-placeholder.svg';
        },
        selectYear(year){

            if ( !year || !this.years.includes(year) )
            {
                this.filters.year = '';
            }
            else
            {
                this.filters.year = year;
            }

        },
        loadNews(){
            this.isLoading = true;

            axios.get(`news/list`)
            .then(response => {
                const { data } = response;

                this.years = data.years;
                this.news = data.news;
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    },
    computed: {
        filteredItems(){
            let list = this.news;

            if ( this.filters.year ) 
            {
                list = list.filter(article => {
                    return article.year === this.filters.year;
                });
            }

            return list;
        },
        displayedItems(){
            return paginate(this.filteredItems, this.pagination.currentPage, this.pagination.perPage);
        }
    },
    mounted(){
        this.loadNews();
    }
}
</script>